import { FC } from 'react';
import { useHistory, useLocation } from 'react-router';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import cn from 'classnames';

const PREFIX = 'AddCredits';

const classes = {
  pageHeader: `${PREFIX}-header`,
  payment: `${PREFIX}-payment`,
  mock: `${PREFIX}-mock`,
  result: `${PREFIX}-result`,
  success: `${PREFIX}-success`,
  error: `${PREFIX}-error`,
};

const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  padding: theme.spacing(5),
  width: '100%',
  height: '100%',

  [`& .${classes.pageHeader}`]: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    gap: '10px',
    margin: theme.spacing(3) + ' 0',
    flexGrow: 0,
    flexShrink: 1,

    '& > h2': {
      margin: 0,
      flexGrow: 1,
      flexShrink: 0,
    }
  },

  [`& .${classes.payment}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    flexShrink: 0,
  },

  [`& .${classes.mock}`]: {
    width: 400,
    height: 200,
    background: 'red',
  },

  [`& .${classes.result}`]: {
    width: 400,
    padding: theme.spacing(3),

    '& header': {
      padding: theme.spacing(3),
      textAlign: 'center',
      color: 'white',
    },

    '& section': {
      padding: theme.spacing(3),
    },

    '& footer': {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,

      '& button': {
        width: '100%',
      }
    },

    [`&.${classes.success}`]: {
      '& header': {
        background: theme.palette.primary.main
      }
    },

    [`&.${classes.error}`]: {
      '& header': {
        background: theme.palette.error.main
      }
    },
  },

}));

interface IAddCredits {}

export const AddCredits: FC<IAddCredits> = () => {
  const history = useHistory();
  const location = useLocation();

  const isPayment = !location.search;
  const isSuccess = location.search.includes('success');
  const isError = location.search.includes('error');

  return <Root>
    <div className={classes.pageHeader}>
      <h2>Add Credits</h2>
    </div>
    <div className={classes.payment}>
      {isPayment && <div className={classes.mock} />}
      {!isPayment &&
        <article className={cn(classes.result, {
          [classes.success]: isSuccess,
          [classes.error]: isError,
        })}>
          <header>
            {isSuccess && 'Payment Success'}
            {isError && 'Payment Failure'}
          </header>
          <section>

          </section>
          <footer>
            <Button onClick={() => history.push('/manage-organisations')} variant="contained" color="primary">Manage Organisations</Button>
            <Button variant="contained" color="info">Contact Support</Button>
          </footer>
        </article>
      }
    </div>
  </Root>;
};
